import { DefaultTheme } from 'styled-components';

import color_scheme from './tokens/color_scheme.json';
import spacing from './tokens/spacing.json';
import radius from './tokens/radius.json';
import effect from './tokens/effect.json';
import tamanho_cartaz from './tokens/tamanho_cartaz.json';

const colors = {
  accent: {
    accent: {
      '1': color_scheme.dark.colors.chippu['1'].value,
      '2': color_scheme.dark.colors.chippu['2'].value,
      '3': color_scheme.dark.colors.chippu['3'].value,
      '4': color_scheme.dark.colors.chippu['4'].value,
      '5': color_scheme.dark.colors.chippu['5'].value,
      '6': color_scheme.dark.colors.chippu['6'].value,
      '7': color_scheme.dark.colors.chippu['7'].value,
      '8': color_scheme.dark.colors.chippu['8'].value,
      '9': color_scheme.dark.colors.chippu['9'].value,
      '10': color_scheme.dark.colors.chippu['10'].value,
      '11': color_scheme.dark.colors.chippu['11'].value,
      '12': color_scheme.dark.colors.chippu['12'].value,
    },
    accent_alpha: {
      '1': color_scheme.dark.colors.chippu_alpha['1'].value,
      '2': color_scheme.dark.colors.chippu_alpha['2'].value,
      '3': color_scheme.dark.colors.chippu_alpha['3'].value,
      '4': color_scheme.dark.colors.chippu_alpha['4'].value,
      '5': color_scheme.dark.colors.chippu_alpha['5'].value,
      '6': color_scheme.dark.colors.chippu_alpha['6'].value,
      '7': color_scheme.dark.colors.chippu_alpha['7'].value,
      '8': color_scheme.dark.colors.chippu_alpha['8'].value,
      '9': color_scheme.dark.colors.chippu_alpha['9'].value,
      '10': color_scheme.dark.colors.chippu_alpha['10'].value,
      '11': color_scheme.dark.colors.chippu_alpha['11'].value,
      '12': color_scheme.dark.colors.chippu_alpha['12'].value,
    },
  },
  neutral: {
    neutral: {
      '1': color_scheme.dark.colors.gray['1'].value,
      '2': color_scheme.dark.colors.gray['2'].value,
      '3': color_scheme.dark.colors.gray['3'].value,
      '4': color_scheme.dark.colors.gray['4'].value,
      '5': color_scheme.dark.colors.gray['5'].value,
      '6': color_scheme.dark.colors.gray['6'].value,
      '7': color_scheme.dark.colors.gray['7'].value,
      '8': color_scheme.dark.colors.gray['8'].value,
      '9': color_scheme.dark.colors.gray['9'].value,
      '10': color_scheme.dark.colors.gray['10'].value,
      '11': color_scheme.dark.colors.gray['11'].value,
      '12': color_scheme.dark.colors.gray['12'].value,
    },
    neutral_alpha: {
      '1': color_scheme.dark.colors.gray_alpha['1'].value,
      '2': color_scheme.dark.colors.gray_alpha['2'].value,
      '3': color_scheme.dark.colors.gray_alpha['3'].value,
      '4': color_scheme.dark.colors.gray_alpha['4'].value,
      '5': color_scheme.dark.colors.gray_alpha['5'].value,
      '6': color_scheme.dark.colors.gray_alpha['6'].value,
      '7': color_scheme.dark.colors.gray_alpha['7'].value,
      '8': color_scheme.dark.colors.gray_alpha['8'].value,
      '9': color_scheme.dark.colors.gray_alpha['9'].value,
      '10': color_scheme.dark.colors.gray_alpha['10'].value,
      '11': color_scheme.dark.colors.gray_alpha['11'].value,
      '12': color_scheme.dark.colors.gray_alpha['12'].value,
    },
  },
  semantic: {
    success: {
      '1': color_scheme.dark.colors.green['1'].value,
      '2': color_scheme.dark.colors.green['2'].value,
      '3': color_scheme.dark.colors.green['3'].value,
      '4': color_scheme.dark.colors.green['4'].value,
      '5': color_scheme.dark.colors.green['5'].value,
      '6': color_scheme.dark.colors.green['6'].value,
      '7': color_scheme.dark.colors.green['7'].value,
      '8': color_scheme.dark.colors.green['8'].value,
      '9': color_scheme.dark.colors.green['9'].value,
      '10': color_scheme.dark.colors.green['10'].value,
      '11': color_scheme.dark.colors.green['11'].value,
      '12': color_scheme.dark.colors.green['12'].value,
    },
    error: {
      '1': color_scheme.dark.colors.red['1'].value,
      '2': color_scheme.dark.colors.red['2'].value,
      '3': color_scheme.dark.colors.red['3'].value,
      '4': color_scheme.dark.colors.red['4'].value,
      '5': color_scheme.dark.colors.red['5'].value,
      '6': color_scheme.dark.colors.red['6'].value,
      '7': color_scheme.dark.colors.red['7'].value,
      '8': color_scheme.dark.colors.red['8'].value,
      '9': color_scheme.dark.colors.red['9'].value,
      '10': color_scheme.dark.colors.red['10'].value,
      '11': color_scheme.dark.colors.red['11'].value,
      '12': color_scheme.dark.colors.red['12'].value,
    },
    warning: {
      '1': color_scheme.dark.colors.amber['1'].value,
      '2': color_scheme.dark.colors.amber['2'].value,
      '3': color_scheme.dark.colors.amber['3'].value,
      '4': color_scheme.dark.colors.amber['4'].value,
      '5': color_scheme.dark.colors.amber['5'].value,
      '6': color_scheme.dark.colors.amber['6'].value,
      '7': color_scheme.dark.colors.amber['7'].value,
      '8': color_scheme.dark.colors.amber['8'].value,
      '9': color_scheme.dark.colors.amber['9'].value,
      '10': color_scheme.dark.colors.amber['10'].value,
      '11': color_scheme.dark.colors.amber['11'].value,
      '12': color_scheme.dark.colors.amber['12'].value,
    },
    info: {
      '1': color_scheme.dark.colors.sky['1'].value,
      '2': color_scheme.dark.colors.sky['2'].value,
      '3': color_scheme.dark.colors.sky['3'].value,
      '4': color_scheme.dark.colors.sky['4'].value,
      '5': color_scheme.dark.colors.sky['5'].value,
      '6': color_scheme.dark.colors.sky['6'].value,
      '7': color_scheme.dark.colors.sky['7'].value,
      '8': color_scheme.dark.colors.sky['8'].value,
      '9': color_scheme.dark.colors.sky['9'].value,
      '10': color_scheme.dark.colors.sky['10'].value,
      '11': color_scheme.dark.colors.sky['11'].value,
      '12': color_scheme.dark.colors.sky['12'].value,
    },
    error_alpha: {
      '1': color_scheme.dark.colors.red_alpha['1'].value,
      '2': color_scheme.dark.colors.red_alpha['2'].value,
      '3': color_scheme.dark.colors.red_alpha['3'].value,
      '4': color_scheme.dark.colors.red_alpha['4'].value,
      '5': color_scheme.dark.colors.red_alpha['5'].value,
      '6': color_scheme.dark.colors.red_alpha['6'].value,
      '7': color_scheme.dark.colors.red_alpha['7'].value,
      '8': color_scheme.dark.colors.red_alpha['8'].value,
      '9': color_scheme.dark.colors.red_alpha['9'].value,
      '10': color_scheme.dark.colors.red_alpha['10'].value,
      '11': color_scheme.dark.colors.red_alpha['11'].value,
      '12': color_scheme.dark.colors.red_alpha['12'].value,
    },
    success_alpha: {
      '1': color_scheme.dark.colors.green_alpha['1'].value,
      '2': color_scheme.dark.colors.green_alpha['2'].value,
      '3': color_scheme.dark.colors.green_alpha['3'].value,
      '4': color_scheme.dark.colors.green_alpha['4'].value,
      '5': color_scheme.dark.colors.green_alpha['5'].value,
      '6': color_scheme.dark.colors.green_alpha['6'].value,
      '7': color_scheme.dark.colors.green_alpha['7'].value,
      '8': color_scheme.dark.colors.green_alpha['8'].value,
      '9': color_scheme.dark.colors.green_alpha['9'].value,
      '10': color_scheme.dark.colors.green_alpha['10'].value,
      '11': color_scheme.dark.colors.green_alpha['11'].value,
      '12': color_scheme.dark.colors.green_alpha['12'].value,
    },
    warning_alpha: {
      '1': color_scheme.dark.colors.amber_alpha['1'].value,
      '2': color_scheme.dark.colors.amber_alpha['2'].value,
      '3': color_scheme.dark.colors.amber_alpha['3'].value,
      '4': color_scheme.dark.colors.amber_alpha['4'].value,
      '5': color_scheme.dark.colors.amber_alpha['5'].value,
      '6': color_scheme.dark.colors.amber_alpha['6'].value,
      '7': color_scheme.dark.colors.amber_alpha['7'].value,
      '8': color_scheme.dark.colors.amber_alpha['8'].value,
      '9': color_scheme.dark.colors.amber_alpha['9'].value,
      '10': color_scheme.dark.colors.amber_alpha['10'].value,
      '11': color_scheme.dark.colors.amber_alpha['11'].value,
      '12': color_scheme.dark.colors.amber_alpha['12'].value,
    },
    info_alpha: {
      '1': color_scheme.dark.colors.sky_alpha['1'].value,
      '2': color_scheme.dark.colors.sky_alpha['2'].value,
      '3': color_scheme.dark.colors.sky_alpha['3'].value,
      '4': color_scheme.dark.colors.sky_alpha['4'].value,
      '5': color_scheme.dark.colors.sky_alpha['5'].value,
      '6': color_scheme.dark.colors.sky_alpha['6'].value,
      '7': color_scheme.dark.colors.sky_alpha['7'].value,
      '8': color_scheme.dark.colors.sky_alpha['8'].value,
      '9': color_scheme.dark.colors.sky_alpha['9'].value,
      '10': color_scheme.dark.colors.sky_alpha['10'].value,
      '11': color_scheme.dark.colors.sky_alpha['11'].value,
      '12': color_scheme.dark.colors.sky_alpha['12'].value,
    },
  },
  default: {
    white: '#ffffffff',
    black: '#202020ff',
  },
};

const variables = {
  misc: {
    white_to_dark: colors.neutral.neutral['1'],
    backdrop: '#000000bf',
    white_to_dark_2: '#00000040',
    dark_to_white: colors.default.white,
    dark_to_white_accent: colors.accent.accent['12'],
  },
  effects: {
    translucent: color_scheme.dark.colors.gray_alpha['2'].value,
    solid: colors.neutral.neutral['2'],
  },
};

const tokens = {
  colors: {
    black_contrast: colors.default.black,
    accent_contrast: colors.default.black,
    page_background: variables.misc.white_to_dark,
    accent_surface: colors.accent.accent_alpha['5'],
    overlay: variables.misc.backdrop,
    text: variables.misc.dark_to_white,
    surface: variables.misc.white_to_dark_2,
    white_contrast: colors.default.white,
    text_accent: variables.misc.dark_to_white_accent,
    text_secondary: colors.neutral.neutral['11'],
    chippu_benefit_background: 'rgba(25, 25, 25, 0.84)',
    news: {
      description: '#808080',
      author: '#353636',
      separator: '#e6e6e6',
    },
  },
};

export function construirSombra(shadowKey: keyof typeof effect.shadows) {
  return Object.entries(effect.shadows[shadowKey])
    .map(([, shadow]) => {
      const { offsetX, offsetY, radius, spread, color } = shadow.value;
      return `${offsetX}px ${offsetY}px ${radius}px ${spread}px ${color}`;
    })
    .join(', ');
}

export type ColorSemanticsValues = Array<
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'error_alpha'
  | 'success_alpha'
  | 'warning_alpha'
  | 'info_alpha'
>;

export type FontFamilyType = 'news' | 'text';

export const colorSemanticsArray = Object.keys(colors.semantic);

export const theme: DefaultTheme = {
  color_scheme,
  colors,
  typography: {
    font: {
      size: {
        '1': 12,
        '2': 14,
        '3': 16,
        '4': 18,
        '5': 20,
        '6': 24,
        '7': 28,
        '8': 32,
        '9': 48,
        '10': 64,
      },
      weight: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
      },
      family: {
        text: 'figtree',
        news: 'quicksand',
      },
      line_height: {
        '1': 16,
        '2': 20,
        '3': 22,
        '4': 25,
        '5': 28,
        '6': 32,
        '7': 36,
        '8': 42,
        '9': 58,
        '10': 64,
      },
    },
  },
  spacing: {
    '1': spacing['2'],
    '2': spacing['3'],
    '3': spacing['4'],
    '4': spacing['5'],
    '5': spacing['6'],
    '6': spacing['7'],
    '7': spacing['8'],
    '8': spacing['9'],
    '9': spacing['10'],
    '10': 76,
    none: 0,
  },
  radius: {
    '1': radius['1'],
    '2': radius['2'],
    '3': radius['3'],
    '4': radius['4'],
    '5': radius['5'],
    '6': radius['6'],
    '7': radius['7'],
    '8': radius['8'],
    '9': radius['9'],
    none: radius.none,
    round: radius.full,
  },
  tamanhoCartaz: {
    height: {
      extraPequeno: tamanho_cartaz['height_extra_pequeno'],
      pequeno: tamanho_cartaz['height_pequeno'],
      medio: tamanho_cartaz['height_medio'],
      grande: tamanho_cartaz['height_grande'],
    },
    width: {
      extraPequeno: tamanho_cartaz['width_extra_pequeno'],
      pequeno: tamanho_cartaz['width_pequeno'],
      medio: tamanho_cartaz['width_medio'],
      grande: tamanho_cartaz['width_grande'],
    },
  },
  tokens,
  panel: {
    solid: variables.effects.solid,
    translucent: variables.effects.translucent,
    translucent_2: tokens.colors.accent_surface,
    accent_solid: colors.accent.accent[4],
    accent_darken: '#192B2D',
  },
  effect,
};
